import React from 'react';
import Notification from './Notification';
import Row from './tag/Row';
import Span from './tag/Span';
import { FormattedMessage } from 'react-intl';
import Loader from './Loader';
import OTIcon from './tag/OTIcon';
import { formatDate } from '../utils/TimeUtils';

/**
 * Basic notification with a title, icon, date, description and actions.
 * Title and description can be supplied either as String or Component with "title"|"description"
 * or with MessageDescriptor with "titleIntl"|"descriptionIntl".
 * For MessageDescriptor format see https://github.com/yahoo/react-intl/wiki/API#message-descriptor
 *
 * @param title           {String}            Notification title
 * @param titleIntl       {MessageDescriptor} Title in react-intl messagedescriptor format
 * @param icon            {String}            icon config conforming to OTIcon type.
 * @param date            {String}            Date shown in the top right of the notification
 * @param dateString      {String}            Preformatted date shown in the top right of the notification
 * @param description     {Component}         Notification description, main content
 * @param descriptionIntl {MessageDescriptor} Description in react-intl messagedescriptor format
 * @param showLoader      {boolean}           Show loader
 * @param actions         {Component}         A slot for notification actions. This can include buttons etc.
 * */
const NotificationWithIcon = ({
  title,
  titleIntl,
  icon,
  date,
  dateString,
  description,
  descriptionIntl,
  showLoader,
  actions,
}) => {
  let _description, _title, _icon, _date;
  if (title) {
    _title = title;
  } else if (titleIntl) {
    _title = <FormattedMessage {...titleIntl} />;
  }

  if (description) {
    _description = description;
  } else if (descriptionIntl) {
    _description = <FormattedMessage {...descriptionIntl} />;
  }

  if (dateString) {
    _date = dateString;
  } else if (date) {
    _date = formatDate(date);
  }

  if (icon) {
    _icon = <OTIcon config={icon} className="ot-notification__icon" />;
  }
  return (
    <Notification>
      <Row>
        {_icon}
        <h2 className="ot-notification__header uppercase">{_title}</h2>
      </Row>
      <Row>
        <Span>
          <div className="ot-notification__description">{_description}</div>
        </Span>
      </Row>
      {showLoader && (
        <Row>
          <Span>
            <Loader />
          </Span>
        </Row>
      )}
      <Row>
        <Span>{actions}</Span>
      </Row>
    </Notification>
  );
};

export default NotificationWithIcon;
